import {translation} from "@2d-front-monorepo/core";
import {IMvvmContextState, MvvmFiles} from "@2d-front-monorepo/design-library";
import {PermitTranslations} from "@2d-front-monorepo/shared-translations";
import {JSX, useMemo} from "react";
import AttachmentType from "../enums/AttachmentType";
import {attachmentTypeLabel} from "../helpers/enumNaming";
import ICreateComponentAttachments from "../interfaces/ICreateComponentAttachments";

export type CreateAttachmentsComponentProps = {
	context: IMvvmContextState<ICreateComponentAttachments>;
	label: string;
	types?: AttachmentType[];
	required?: boolean;
}

function validateSize(value: FileList | undefined): string | undefined {
	if (!value) return undefined;

	const totalSize = Array.from(value).reduce((acc, file) => acc + file.size, 0);
	if (totalSize > 10000000) {
		return translation(PermitTranslations.validation__generic__max_size, {value: 10});
	}
	return undefined;
}

export function CreateAttachmentComponent({context, type, required}: {
	context: IMvvmContextState<ICreateComponentAttachments>,
	type: AttachmentType,
	required?: boolean
}): JSX.Element {
	const label = translation(attachmentTypeLabel(type));

	const validation = useMemo(() => {
		return required
			? {
				required: translation(PermitTranslations.validation__generic__required, {value: label.toLowerCase()}),
				validate: validateSize
			}
			: {
				validate: validateSize
			};
	}, [required, label]);

	return <MvvmFiles context={context}
					  // @ts-ignore
		              property={"attachments." + type}
		              label={label}
		              validation={validation}
		              multiple
		              accept=".png,.jpg,.jpeg,.pdf,image/png,image/jpeg,application/pdf"/>
}

export default function CreateAttachmentsComponent(props: CreateAttachmentsComponentProps): JSX.Element | undefined {
	const {required, context, types, label} = props;
	return types != null && types.length > 0 ? <div className="layout vertical">
		<h5>{label}</h5>
		<hr className="no-margin-start"/>
		{types.map((t, i) => (
			<CreateAttachmentComponent key={i}
			                           context={context}
			                           type={t}
			                           required={required}/>)
		)}
	</div> : undefined;
};
